export default {
  LOAD_SESSION_QR_DISPLAY_START: 'LoadSessionQrDisplayPageStart',
  LOAD_SESSION_QR_DISPLAY_END: 'LoadSessionQrDisplayPageEnd',
  SET_SESSION_QR_DISPLAY_DISABLED: 'SetSessionQrDisplayDisabled'
};
